import React, { useState } from 'react';
import { resolveSiteImage, useSiteContent } from '../context/SiteContentContext';
import './Navbar.css';

const navItems = [
  { href: '#inicio', label: 'Inicio' },
  { href: '#sobre-mi', label: 'Sobre mí' },
  { href: '#servicios', label: 'Servicios' },
  { href: '#recomendaciones', label: 'Recomendaciones' },
  { href: '#testimonios', label: 'Testimonios' },
  { href: '#contacto', label: 'Contacto', cta: true }
];

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const { images } = useSiteContent();

  const closeMenu = () => setIsOpen(false);

  return (
    <header className="site-header">
      <nav className="navbar" aria-label="Principal">
        <a href="#inicio" className="brand" onClick={closeMenu}>
          <img src={resolveSiteImage(images.logo.src)} alt={images.logo.alt} className="logo" />
          <span className="brand-copy">
            <strong>Babyplanner Vero</strong>
            <span>Maternidad organizada</span>
          </span>
        </a>

        <button
          className={`hamburger ${isOpen ? 'is-open' : ''}`}
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Abrir navegación"
          aria-expanded={isOpen}
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </button>

        <div className={`nav-links ${isOpen ? 'open' : ''}`}>
          {navItems.map((item) => (
            <a
              href={item.href}
              className={`nav-link ${item.cta ? 'nav-cta' : ''}`}
              key={item.href}
              onClick={closeMenu}
            >
              {item.label}
            </a>
          ))}
        </div>
      </nav>
    </header>
  );
}

export default Navbar;
